export default __webpack_public_path__ + "static/media/039-bell.5bfc549f.png";